import React from 'react';
import './ProgressBar.less';

type Props = {

}

class ProgressBar extends React.Component {

  description: 'Displays a progress bar.'

  props: Props

  constructor(props: Props) {
    super(props);
  }

  /* Component Custom Methods */
  /* End Component Custom Methods */

  /* React Component LifeCycle Methods */
  //componentWillMount() {}
  //componentDidMount() {}
  //componentWillReceiveProps(nextProps) {}
  //shouldComponentUpdate(nextProps, nextState) {}
  //componentWillUpdate(nextProps, nextState) {}
  //componentDidUpdate(prevProps, prevState) {}
  //componentWillUnmount() {}
  render() {
    return (
      <div className="progress-bar">
        <div className="progress" style={ {width: this.props.percentage} }>
        </div>
        <div className="progress-txt" >{ this.props.percentage }</div>
      </div>
    );
  }
  /* End React Component LifeCycle Methods */
}

export default ProgressBar;

//Unit test entry point
export const ProgressBarTest = ProgressBar;


/** WEBPACK FOOTER **
 ** ./src/js/app/ProgressBar/ProgressBar.jsx
 **/